export default () => {

    const checkbox = document.getElementById('MembershipForm_MembershipForm_CreateAccount');
    const passwords = document.querySelectorAll('div.password-container');
    if (checkbox) {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                for (const password of passwords) {
                    password.style.display = 'initial';
                }
            } else {
                for (const password of passwords) {
                    password.style.removeProperty('display');
                }
            }
        });
    }

}
